import styled from 'styled-components';
import ButtonLoading from './ButtonLoading';

export default styled(ButtonLoading)`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;

  .button-loading {
    display: flex;
    width: 100%;

    &__button {
      &:hover {
        text-decoration: none;
      }
    }
    &__container {
      align-items: center;
      display: flex;
      justify-content: center;
    }

    &__icon {
      margin: 0;
      margin-right: 0.5rem;
      font-size: 2rem;
      height: 2.6rem;
      &--loading {
        animation: rotate 1s infinite linear;
      }
    }
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
